import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import MovieList from "./components/MovieList";
import MoviePlayer from "./components/MoviePlayer";
import LoginPage from "./pages/LoginPage";
import AcademicHomePage from "./pages/AcademicHomePage";
import DashboardPage from "./pages/DashboardPage";
import DigitalLibraryPage from "./pages/DigitalLibraryPage";
import LearningResultsPage from "./pages/LearningResultsPage";
import PrivateRoute from "./components/PrivateRoute";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Footer from "./components/Footer";
import axios from "./lib/axios";
import SessionExpiredModal from "./components/SessionExpiredModal";

// 👇 เพิ่ม import หน้าที่ยังไม่ได้เพิ่ม
import ProfilePage from "./pages/ProfilePage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import AdminPage from "./pages/AdminPage";

const AppContent = () => {
  const [sessionExpired, setSessionExpired] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const resInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          // ป้องกันการเปิด modal หลายครั้งพร้อมกัน
          if (!sessionExpired) {
            setSessionExpired(true);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(resInterceptor);
    };
  }, [sessionExpired]);

  const handleCloseModal = async () => {
    setSessionExpired(false);

    // ใช้ logout function จาก AuthContext เพื่อเคลียร์ข้อมูลอย่างถูกต้อง
    try {
      await logout();
    } catch (error) {
      console.warn("Logout error during session expiration:", error);
    }

    // เคลียร์ localStorage เพิ่มเติมเพื่อให้แน่ใจ
    localStorage.clear();

    // นำทางกลับไปหน้าหลักด้วย React Router
    navigate("/academic", { replace: true });
  };

  return (
    <>
      <AnalyticsTracker />

      <Routes>
        {/* Redirect หน้าแรกไปที่หน้าวิชาการ */}
        <Route path="/" element={<Navigate to="/academic" replace />} />

        {/* หน้าวิชาการสำหรับผู้ที่ไม่ได้ล็อคอิน */}
        <Route path="/academic" element={<AcademicHomePage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* หน้าแรกหลังล็อกอินเรียบร้อย (Dashboard) */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />

        {/* หลักสูตรออนไลน์สำหรับผู้ที่ล็อคอินแล้ว */}
        <Route
          path="/courses"
          element={
            <PrivateRoute>
              <MovieList />
            </PrivateRoute>
          }
        />

        <Route
          path="/learn/:id"
          element={
            <PrivateRoute>
              <MoviePlayer />
            </PrivateRoute>
          }
        />

        {/* ✅ เพิ่มเส้นทางใหม่ */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <ChangePasswordPage />
            </PrivateRoute>
          }
        />

        {/* ห้องสมุดดิจิตอล */}
        <Route
          path="/digital-library"
          element={
            <PrivateRoute>
              <DigitalLibraryPage />
            </PrivateRoute>
          }
        />

        {/* ผลการเรียน */}
        <Route
          path="/learning-results"
          element={
            <PrivateRoute>
              <LearningResultsPage />
            </PrivateRoute>
          }
        />

        {/* หน้าแอดมิน - เฉพาะ smoker8888 */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminPage />
            </PrivateRoute>
          }
        />
      </Routes>

      <Footer />

      <SessionExpiredModal
        visible={sessionExpired}
        onClose={handleCloseModal}
      />
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
